import axios from "axios";

class SalesOpportunityService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_SALES_OPPORTUNITY_URL;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    submitCommonLead(data) {
        return this.restClient.post(`/commonLead`, {
            "dealSheetNo": data.dealSheetNo,
            "dealDesc": data.dealDesc,
            "dealPackageName": data.dealPackageName,
            "dealReferenceNumber": data.dealReferenceNumber,
            "dealModel": data.dealModel,
            "totalMonthlySubscription": data.totalMonthlySubscription,
            "comments": data.comments,
            "firstName": data.firstName,
            "mobileNumber": data.mobileNumber,
            "emailAddress": data.emailAddress,
            "businessSize": data.businessSize,
            "province": data.province,
            "businessName": data.businessName,
            "leadType": data.leadType,
            "requestType": data.requestType,
            "interest" : data.interest
        })
    }

    submitEmailLead(data) {
        return this.restClient.post(`/email/lead`, {
            "comments": data.comments,
            "firstName": data.firstName,
            "mobileNumber": data.mobileNumber,
            "emailAddress": data.emailAddress,
            "businessSize": data.businessSize,
            "province": data.province === "The Western Cape" ? "Western Cape" : data.province,
            "businessName": data.businessName,
            "alternateContactNumber": data.alternateContactNumber,
            "requestType": data.requestType,
            "interest" : data.interest,
            "sector": data.sector
        })
    }



}

export default new SalesOpportunityService();
